import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class FatalStreamError extends Error {
    constructor(message, status, errorCode){
        super(message), _define_property(this, "status", void 0), // WHY: the status is shared with real failures; only the code tells a refusal apart.
        _define_property(this, "errorCode", void 0);
        this.name = 'FatalStreamError';
        this.status = status;
        this.errorCode = errorCode;
    }
}
export const agenticErrorCodeOf = (err)=>err instanceof FatalStreamError && err.errorCode != null ? err.errorCode : null;
